import { MetaPartnerProductsApiClient } from '@fourthwall/services/dist/MetaPartnerProductsApiClient'
import { createQueryHook } from '@fourthwall/utils'

export const useMetaProductsQuery = createQueryHook(
  MetaPartnerProductsApiClient.getMetaPartnerProducts,
  {
    queryKey: ['metaProducts'],
  },
)
